import type { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import GroupIdentityContext from "src/contexts/data/GroupIdentityContext";
import type { GetGroupIdentityByIdResponse } from "src/api/Tmd.dtos";
import useGroupIdentityById from "src/hooks/data/load/useGroupIdentityById";
import type { SWRConfiguration } from "swr";

interface IGroupProviderProps extends PropsWithChildren {
    id?: number;
    configuration?: SWRConfiguration<GetGroupIdentityByIdResponse, GetGroupIdentityByIdResponse>;
}

const GroupIdentityProvider: FC<IGroupProviderProps> = ({ children, id, configuration }) => {
    const context = useGroupIdentityById(id, configuration);

    return (
        <GroupIdentityContext.Provider value={context}>{children}</GroupIdentityContext.Provider>
    );
};

export const RouteGroupIdentityProvider: FC<PropsWithChildren> = ({ children }) => {
    const { groupId } = useParams<{ groupId: string }>();
    const id = groupId ? parseInt(groupId, 10) : undefined;

    return <GroupIdentityProvider id={id}>{children}</GroupIdentityProvider>;
};

export default GroupIdentityProvider;
